import React from 'react'
import Settings from '../../components/Setting'

function SettingPage() {
  return (
    <><Settings/></>
  )
}

export default SettingPage